module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_1_null@2x.eee2cdb6.png";